interface EquityTargetCellProps {
    displayValue: string;
    inputValue: number | string;
    disabled: boolean;
    onChange: (value: string) => void;
}

const EquityTargetCell = (
    {
        displayValue,
        inputValue,
        disabled,
        onChange,
    }: EquityTargetCellProps) => {
    return (
        <div className="flex items-center gap-2 justify-center">
            <span className="font-semibold">{displayValue}</span>
            <span className="text-gray-400">/</span>
            <input
                type="number"
                min="0"
                max="999"
                disabled={disabled}
                value={inputValue}
                onChange={(e) => onChange(e.target.value)}
                className="w-16 py-1 text-center border border-gray-400 rounded focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
        </div>
    );
};

export default EquityTargetCell;
